// const baseurls = "http://localhost:3000/api/beiraBoladas";
const baseurls = 'https://chapa100.onrender.com/api/beiraBoladas';

export default class routersName {
  auction = `${baseurls}/auction`;
  photo = `${baseurls}/photo`;
  categories = `${baseurls}/categories`;
  anaucement = `${baseurls}/anaucement`;
  userAdmin = `${baseurls}/userAdmin`;
  annoucementListClient = `${baseurls}/client`;
  auctionqueryUsar = `${baseurls}/clientaution`;
}
